import { queryKeys as paymentQueryKeys } from '@pages/paymentV2/utils/constants/queryKeys';
import { $api } from '@service/RequestService';
import { queryNames } from '@utils/constants/queryNames';
import { useMutation, useQueryClient } from 'react-query';

import { clientConstants } from '..';

export const useClientPaymentDelete = () => {
  const qc = useQueryClient();

  return useMutation(
    async (data: { clientId: number; paymentId: number; cancelNote: string }) => {
      const res = await $api.delete('/v1/client/payment', { data });

      return res.data;
    },
    {
      onSuccess: async (_, { clientId }) => {
        qc.invalidateQueries([paymentQueryKeys.PAYMENT]);
        await qc.invalidateQueries([clientConstants.queryKeys.CLIENT_ID_PAYMENT_V2, Number(clientId)]);
        await qc.invalidateQueries([queryNames.CLIENT_VIEW, String(clientId)]);
      }
    }
  );
};
